// Consent Mode bootstrap lives in the shared head partial.
// Mediavine is expected to propagate consent to Google via TCF.
